export * from './aspire-logo.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/aspire-logo/index.ts